import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Entity } from "../../types/entity";

interface EntityListItemProps {
  entity: Entity;
  onToggle: (id: string) => void;
}

const EntityListItem = ({ entity, onToggle }: EntityListItemProps) => {
  return (
    <Box
      onClick={() => onToggle(entity.id)}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 26px 12px 16px",
        backgroundColor: entity.selected ? "rgba(0, 128, 128, 0.08)" : "white",
        borderBottom: entity.selected
          ? "1px solid rgba(0, 128, 128, 0.3)"
          : "1px solid rgba(0, 0, 0, 0.12)",
        borderTop: entity.selected
          ? "1px solid rgba(0, 128, 128, 0.3)"
          : "none",
        cursor: "pointer",
        transition: "all 0.2s",
        "&:hover": {
          backgroundColor: entity.selected
            ? "rgba(0, 128, 128, 0.12)"
            : "rgba(0, 0, 0, 0.04)",
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        {entity.selected ? (
          <CheckCircleIcon sx={{ color: "primary.main", fontSize: 20 }} />
        ) : (
          <RadioButtonUncheckedIcon
            sx={{ color: "rgba(0, 0, 0, 0.26)", fontSize: 20 }}
          />
        )}
        <Box
          sx={{
            display: "flex",
            color: "primary.main",
            fontSize: 20,
          }}
        >
          {entity.icon}
        </Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: entity.selected ? 600 : 400,
            color: entity.selected ? "primary.main" : "text.primary",
          }}
        >
          {entity.name}
        </Typography>
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          fontWeight: 500,
        }}
      >
        {entity.count}
      </Typography>
    </Box>
  );
};

export default EntityListItem;
